import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-types" }
const _hoisted_2 = { class: "main-box" }
const _hoisted_3 = { class: "wrapper-box" }
const _hoisted_4 = ["aria-checked", "onClick", "onKeydown"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "checked"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "label-select" }
const _hoisted_9 = {
  key: 0,
  class: "wrapper-box-circle"
}

import { TypeItem } from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import { toRefs } from 'vue'

interface EMITS {
  (e: 'emitId', id: string, checked: boolean)
}
interface PROPS {
  typeItems: TypeItem[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ListTypeItems',
  props: {
    typeItems: {}
  },
  emits: ["emitId"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const { typeItems } = toRefs(props)
function emitId(id: string, checked: boolean) {
  checked = !checked
  emits('emitId', id, checked)
}
function handleSpaceKey(event: KeyboardEvent, id: string, visible: boolean) {
  event.preventDefault()
  emitId(id, visible)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeItems), (typeItem) => {
      return (_openBlock(), _createElementBlock("div", {
        key: typeItem.id,
        class: "type-container"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              "aria-checked": typeItem.visible,
              class: "wrapper-box-checkbox checkbox",
              role: "checkbox",
              tabindex: "0",
              onClick: ($event: any) => (emitId(typeItem.id, typeItem.visible)),
              onKeydown: _withKeys((event) => handleSpaceKey(event, typeItem.id, typeItem.visible), ["space"])
            }, [
              _createElementVNode("label", {
                for: typeItem.id,
                class: "checkbox__label"
              }, null, 8, _hoisted_5),
              _createElementVNode("input", {
                id: typeItem.id,
                checked: typeItem.visible,
                tabindex: "-1",
                type: "checkbox"
              }, null, 8, _hoisted_6),
              _createElementVNode("span", {
                for: typeItem.id,
                class: "checkmark"
              }, null, 8, _hoisted_7)
            ], 40, _hoisted_4),
            _createElementVNode("div", {
              class: "wrapper-box-label",
              style: _normalizeStyle(typeItem.color ? 'max-width: 80%' : '')
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(typeItem.name), 1)
            ], 4),
            (typeItem.color)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", {
                    class: "circle",
                    style: _normalizeStyle({ backgroundColor: typeItem.color })
                  }, null, 4)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})